/** Helpers for seller booking cut-off UI (matches API booking_cutoff_minutes 0–10080). */

export type CutoffUnit = "hours" | "minutes";

const MAX_BOOKING_CUTOFF_MINUTES = 10080;

export function minutesToCutoffFields(total: number): {
  value: string;
  unit: CutoffUnit;
} {
  const m = Math.min(
    MAX_BOOKING_CUTOFF_MINUTES,
    Math.max(0, Math.floor(Number.isFinite(total) ? total : 0)),
  );
  if (m === 0) {
    return { value: "0", unit: "minutes" };
  }
  if (m >= 60 && m % 60 === 0) {
    return { value: String(m / 60), unit: "hours" };
  }
  return { value: String(m), unit: "minutes" };
}

export function cutoffFieldsToMinutes(
  value: string | undefined,
  unit: CutoffUnit,
): number {
  const trimmed = (value ?? "").trim();
  const n =
    trimmed === "" ? 0 : Number.parseInt(trimmed.replace(/\s/g, ""), 10);
  if (!Number.isFinite(n) || n < 0) {
    return 0;
  }
  const intPart = Math.floor(n);
  if (unit === "hours") {
    const maxHours = MAX_BOOKING_CUTOFF_MINUTES / 60;
    return Math.min(maxHours * 60, intPart * 60);
  }
  return Math.min(MAX_BOOKING_CUTOFF_MINUTES, intPart);
}
